import script from "./TrainerAcademyModulesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TrainerAcademyModulesPage.vue?vue&type=script&setup=true&lang=js"

import "./TrainerAcademyModulesPage.vue?vue&type=style&index=0&id=1de96031&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1de96031"]])

export default __exports__